module.exports = __webpack_public_path__ + "static/sf-20-percent-199c0820946f63669f81262737c0c14e.png";